import { useMediaQuery } from '@mui/material';

type PropTypes = {
  interiorGalleryMid: any;
  exteriorGalleryMid: any;
  interiorGalleryLow: any;
  exteriorGalleryLow: any;
};

export default function GenerateImageListData(props: PropTypes) {
  const {
    interiorGalleryMid,
    exteriorGalleryMid,
    interiorGalleryLow,
    exteriorGalleryLow,
  } = props;

  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  const galleryData = [];

  const isInteriorMidEmpty = interiorGalleryMid.length === 0;
  const isExteriorMidEmpty = exteriorGalleryMid.length === 0;

  const isInteriorLowEmpty = interiorGalleryLow.length === 0;
  const isExteriorLowEmpty = exteriorGalleryLow.length === 0;

  if (isMobile) {
    if (isInteriorMidEmpty) {
      galleryData.push({
        gallery: exteriorGalleryMid,
        tab: 'gallery-exterior',
      });
    } else if (isExteriorMidEmpty) {
      galleryData.push({
        gallery: interiorGalleryMid,
        tab: 'gallery-interior',
      });
    } else {
      galleryData.push(
        { gallery: exteriorGalleryMid, tab: 'gallery-exterior' },
        { gallery: interiorGalleryMid, tab: 'gallery-interior' },
      );
    }
  } else {
    if (isInteriorLowEmpty) {
      galleryData.push({
        gallery: exteriorGalleryLow,
        tab: 'gallery-exterior',
      });
    } else if (isExteriorLowEmpty) {
      galleryData.push({
        gallery: interiorGalleryLow,
        tab: 'gallery-interior',
      });
    } else {
      galleryData.push(
        { gallery: exteriorGalleryLow, tab: 'gallery-exterior' },
        { gallery: interiorGalleryLow, tab: 'gallery-interior' },
      );
    }
  }

  return galleryData;
}
